<div class="common-field">
  <div class="common-field__content">
    <ng-content></ng-content>
  </div>
</div>
